import { css } from "@emotion/react";

export const inputStyles = css`
  width: 100%;
`;

export const containerStyles = css`
  position: relative;
  display: inline-block;
  width: 100%;
`;
